/* src/app/platform-redirect/platform-redirect.component.css */
/*# sourceMappingURL=platform-redirect.component.css.map */
